import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Block } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { memo } from "react";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import LightGallary from "app/common/LightGallary";
import { getDateTime, isRoleViewSensitiveImage } from "app/common/LocalFunction";
import { SENSITIVE_PLACEHOLDER_IMAGE } from "app/common/LocalConst";

const TreatmentResultPopup = ({
  open,
  handleClose,
  onSubmit,
  initialValues,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const department = useDefaultDepartment();

  return (
    <PopupForm
      open={open}
      size="lg"
      handleClose={handleClose}
      title={`Kết quả điều trị`}
      formik={{
        initialValues: {
          ...initialValues,
        },
        onSubmit: onSubmit,
        enableReinitialize: true,
      }}
      action={({ isSubmitting }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(({ listVatPercent, patient }) => {
  const { setFieldValue, values } = useFormikContext();
  const isViewSensitive = isRoleViewSensitiveImage();

  const renderImages = (images, isSensitive) => {
    if (isSensitive && !isViewSensitive) {
      return (images || []).map((el, ind) => (
        <a
          key={ind}
          href={SENSITIVE_PLACEHOLDER_IMAGE}
          data-src={SENSITIVE_PLACEHOLDER_IMAGE}
          data-sub-html={el?.fileDescription?.name || ""}
          className="item-img-gallery"
          title="Ảnh nhạy cảm – cần quyền để xem"
        >
          <img
            src={SENSITIVE_PLACEHOLDER_IMAGE}
            alt={el?.fileDescription?.name}
            title={el?.fileDescription?.name}
            style={{
              width: "100%",
              maxWidth: "120px",
              height: "120px",
              objectFit: "cover",
              borderRadius: "4px",
              border: "1px solid #eee",
            }}
          />
        </a>
      ));
    }

    return (images || []).map((el, ind) => (
      <a
        key={ind}
        href={el?.fileDescription?.fileData}
        data-src={el?.fileDescription?.fileData}
        data-sub-html={el?.fileDescription?.name || ""}
        className="item-img-gallery"
      >
        <img
          src={el?.fileDescription?.fileData}
          alt={el?.fileDescription?.name}
          style={{
            width: "100%",
            maxWidth: "120px",
            height: "120px",
            objectFit: "cover",
            borderRadius: "4px",
            border: "1px solid #eee",
          }}
        />
      </a>
    ));
  };

  return (
    <>
      <Grid container spacing={1} className="form-treatment">
        <Grid item xs={12} md={4}>
          <ul className="patient-info-group">
            <li><span className="label">Thông tin điều trị</span></li>
            <li>🕒 <span className="label">Thời gian thực hiện:</span> {getDateTime(values?.diagnosticReport?.performDate)}</li>
            <li>🙋‍♀️ <span className="label">Người thực hiện:</span> {values?.diagnosticReport?.practitioner?.staffName}</li>
            <li>✅ <span className="label">Kết quả:</span> {values?.diagnosticReport?.conclude}</li>
            <li>📝 <span className="label">Mô tả:</span> {values?.diagnosticReport?.note}</li>
          </ul>
        </Grid>
        <Grid item xs={12} md={2}></Grid>
        <Grid item xs={12} md={4}>
          <ul className="patient-info-group">
            <li><span className="label">Hẹn điều trị</span></li>
            <li>🏢 <span className="label">Cơ sở:</span> {values?.appointment?.department?.name}</li>
            <li>🕒 <span className="label">Thời gian điều trị kế tiếp:</span> {getDateTime(values?.appointment?.startTime)}</li>
            <li>📝 <span className="label">Nội dung điều trị kế tiếp:</span> {values?.appointment?.note}</li>
          </ul>
        </Grid>
        <Grid item xs={12} md={2}></Grid>

        <Grid item xs={12} md={6}>
          <div className="section-title">Ảnh trước điều trị</div>
          <LightGallary>
            {renderImages(values?.diagnosticReport?.imagesBeforeTreatment, values?.service?.isSensitive)}
          </LightGallary>
        </Grid>

        <Grid item xs={12} md={6}>
          <div className="section-title">Ảnh sau điều trị</div>
          <LightGallary>
            {renderImages(values?.diagnosticReport?.imagesAfterTreatment, values?.service?.isSensitive)}
          </LightGallary>
        </Grid>
      </Grid>
    </>
  );
});

export default memo(TreatmentResultPopup);
